import { Link } from "react-router-dom";
import { FaCheckCircle} from "react-icons/fa";
import banner from "../../assets/images/trustworthy-about-banner.jpg";
import aboutImg from "../../assets/images/about-img-1.jpg";
import Features from "./Home/Features.jsx";
import FrechiseCta from "./Home/FrechiseCta.jsx";
import Services from "../Pages/Home/Services.jsx";

const AboutUS = () => {
  return (
    <>
      <section className="inner-banner">
        <img src={banner} alt="About Us Banner" className="inner-banner-img" />

        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>About Us</h1>

              <p>
                We are a leading provider of servicing and repairing household
                machines at the owner’s location rather than bringing them to
                our workshop.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT INTRO */}
      <section className="about-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2>We Provide Trusted Home Services</h2>
              <p>
                Sevasati is a trusted professional home service company
                dedicated to delivering reliable, affordable, and high-quality
                solutions for everyday household needs. We connect customers
                with skilled and verified technicians who are trained to handle
                services with precision, safety, and care.
              </p>

              <p>
                Our mission is to simplify home maintenance by offering
                transparent pricing, timely service, and consistent quality.
                From minor repairs to major service requirements, our
                experienced professionals ensure every job is completed
                efficiently and to the highest standards.
              </p>

              <p>
                At Sevasati, customer satisfaction is at the heart of everything
                we do. We continuously improve our processes, embrace
                technology, and focus on building long-term trust by delivering
                dependable services you can rely on—every time.
              </p>

              <ul className="about-list">
                <li>
                  <FaCheckCircle /> Certified & Skilled Professionals
                </li>
                <li>
                  <FaCheckCircle /> Transparent Pricing
                </li>
                <li>
                  <FaCheckCircle /> 24/7 Customer Support
                </li>
              </ul>
            </div>

            <div className="col-lg-6">
              <img src={aboutImg} alt="about" className="img-fluid about-img" />
            </div>
          </div>
        </div>
      </section>

      <Services />

      <Features />
      <FrechiseCta />
    </>
  );
};

export default AboutUS;
